
// ** React Imports
import axios from "axios";
import React, { Fragment, useState } from "react";
// ** Custom Components
import { useQuery, useQueryClient } from "react-query";
import "./style.css"
// ** Third Party Componentsr4
import { Bell } from "react-feather";
// ** Reactstrap Imports
import Avatar from "@components/avatar";
import classnames from "classnames";
import { toast } from "react-toastify";
import {
  Badge,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import { REST_API_WORKSUITE_V3 } from "../../../../constants";
import { handleRequestErrors } from "../../../../views/apps/ecommerce/utils/utils";
import PillFilled from "./PillFilled";

const user = JSON.parse(localStorage.getItem("userData"));
const token = `Bearer ${user?.data?.token}`;
const token_company = localStorage?.getItem("token_company");

const readNotification = () => {
  const config = {
    method: "post",
    url: `${REST_API_WORKSUITE_V3}notifications/all`,
    headers: {
      Authorization: token,
      "X-WorkSuite-Company-Token": token_company,
    },
  };
  try {
    const res = axios(config);
    toast.success("Read Notification Successfully!");
    return location.reload();
  } catch (error) {
    return handleRequestErrors(error);
  }
};

export const getNotification = async () => {
  const config = {
    method: "get",
    url: `${REST_API_WORKSUITE_V3}notifications`,
    headers: {
      Authorization: token,
      "X-WorkSuite-Company-Token": token_company,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return handleRequestErrors(error);
  }
};

const NotificationDropdown = () => {
  const queryClient = useQueryClient();

  const { data: data, isLoading: isLoadingNotification } = useQuery(
    ["listNotifications", token],
    () => token && getNotification(),
    { refetchOnWindowFocus: false }
  );

  return (
    <UncontrolledDropdown
      tag="li"
      className="dropdown-notification nav-item me-25 notification-tab-pane"

    >
      <DropdownToggle
        tag="a"
        className="nav-link"
        href="/"
        onClick={(e) => e.preventDefault()}
      >
        <Bell size={21} />
        {data?.data?.length > 0 ? (
          <Badge pill color="danger" className="badge-up">
            {data?.data?.length ?? 0}
          </Badge>
        ) : (
          ""
        )}
      </DropdownToggle>
      <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0">
      <li className="dropdown-menu-header">
        </li>
        <div style={{paddingLeft:"1rem", paddingRight:"1rem", paddingTop:"1rem"}}>
          <PillFilled data={data} queryClient={queryClient} />
        </div>
        <li className="dropdown-menu-footer">
          <Button color="primary" outline onClick={readNotification} block>
            Mark as Read
          </Button>
        </li>
      </DropdownMenu>

    </UncontrolledDropdown>
  );
};

export default NotificationDropdown;

